import { render, staticRenderFns } from "./MtoSectorFormDialog.vue?vue&type=template&id=73bcf214&scoped=true"
import script from "./MtoSectorFormDialog.vue?vue&type=script&lang=js"
export * from "./MtoSectorFormDialog.vue?vue&type=script&lang=js"
import style0 from "./MtoSectorFormDialog.vue?vue&type=style&index=0&id=73bcf214&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73bcf214",
  null
  
)

export default component.exports